<template>
  <div :class="{emptypage: showEmptyPage}">
    <div :class="'banner site-' + SITE_CONFIG.site">
      <div :class="{flexer: true}">
        <h1>
          {{ $t('general.cta.book') }}
          <span>{{ $t('general.skirental') }}</span><span v-if="SITE_CONFIG.skischool.onsite">, {{ $t('general.school') }}</span><span v-if="SITE_CONFIG.skischool.onsite">, {{ $t('general.skipass') }}</span>
        </h1>

        <LanguageSwitcher
          type="row"
          :class="{disabled: loading}"
          @clickedlanguage="setLoading"
          @pickedlanguage="pickedLanguage" />

        <div :class="{buttons: true, show: (hasPickedLanguage && !onlySkirental), disabled: loading}">
          <button @click="goToSkirental()">{{ $t('general.skirental') }}</button>
          <button @click="goToSkischool()" v-if="SITE_CONFIG.skischool.onsite">{{ $t('general.school') }}</button>
          <button @click="goToSkipass()" v-if="SITE_CONFIG.skipass.onsite">{{ $t('general.skipass') }}</button>
        </div>
      </div>
    </div>
    <Loading :show="showEmptyPage || loading" />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Loading from '@/components/components/Loading';
import LanguageSwitcher from '@/components/components/LanguageSwitcher';

export default {
  data() {
    return {
      intervalRef: null,
      resetSecondsLeft: 0,
      showEmptyPage: false,
      loading: false,
      hasPickedLanguage: false,
    };
  },
  computed: {
    ...mapGetters([
      'guidedRentals',
    ]),
    onlySkirental() {
      if (this.SITE_CONFIG.skischool.onsite) {
        return false;
      }
      if (this.SITE_CONFIG.skipass.onsite) {
        return false;
      }
      return true;
    },
  },
  components: {
    Loading,
    LanguageSwitcher,
  },
  created() {
    window.addEventListener('mousemove', this.resetTimer);
    window.addEventListener('click', this.resetTimer);
    window.addEventListener('keyup', this.resetTimer);

    const refresh = parseInt(this.$route.query.refresh, 10);

    if (this.$route.query.refresh && refresh === 1) {
      this.showEmptyPage = true;
    }
  },
  destroyed() {
    clearInterval(this.intervalRef);
  },
  mounted() {
    this.setOnSite();
    this.clearCart();

    const refresh = parseInt(this.$route.query.refresh, 10);

    if (this.$route.query.key) {
      this.$store.state.onsite_key = this.$route.query.key;
    }

    if (this.$route.query.refresh && refresh === 1) {
      localStorage.setItem('language', 'sv');

      const route = {
        name: this.$route.name,
        query: Object.assign({}, this.$route.query),
      };
      route.query.refresh = 0;
      this.$router.replace(route);
      window.location.reload();
      return;
    }

    this.$store.state.isOnWhichSite = this.$route.query.site;
    if (!this.$route.query.site) {
      alert('Lägg på en site med ?site=X'); //eslint-disable-line
      return;
    }

    this.resetTimer();

    this.$nextTick(() => {
      this.intervalRef = setInterval(() => {
        this.resetSecondsLeft -= 1;
        if (this.resetSecondsLeft < 0) {
          window.location.reload();
        }
      }, 1000);
    });
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
      'setOnSite',
      'clearCart',
    ]),
    setLoading() {
      this.loading = true;
    },
    pickedLanguage() {
      this.hasPickedLanguage = true;
      this.loading = false;

      if (this.onlySkirental) {
        this.goToSkirental();
      }
    },
    resetTimer() {
      this.resetSecondsLeft = (5 * 60);
    },
    goToSkirental() {
      this.$router.replace({
        path: '/skidhyra-pa-plats',
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 0,
        },
      });
    },
    goToSkischool() {
      this.$router.replace({
        path: '/skidskola-pa-plats',
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 0,
        },
      });
    },
    goToSkipass() {
      this.$router.replace({
        path: '/liftkort-pa-plats',
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 0,
        },
      });
    },
  },
};
</script>

<style lang="stylus">
body
  background-color white
</style>

<style scoped lang="stylus">
@import '~@/global.styl'

.flexer
  display: flex;
  align-items: center;
  // justify-content: center;
  flex-direction: column;
  width: 100vw
  height: 100vh
  width: 100vw;
  height: 100vh;
  // background-color: rgba(0,0,0,0.8);
  overflow: auto;
  padding-top 100px
  button
    margin 15px

.buttons
  opacity: 0
  transition: all 0.2s
  &.show
    opacity: 1
    &.disabled
      disabled()

.emptypage
  .banner
    background-image none
    display: none

&.disabled
  disabled()

.banner
  height 100vh
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/onsite-splash.jpg)
  background-position center
  position relative
  padding 0
  &.site-branas
    background-image url(https://static.booking.branasgruppen.se/static/img/onsite-splash-branas.jpg)

h1
  bottom 0
  max-width 100%
  padding 15px 5px
  margin-bottom 15px
  color white
  united-heavy()
  uppercase()
  centered()
  font-size: 46px;

.ingress
  width 674px
  font-size 17px
  font-weight bold
  margin 25px auto
  text-align center

.info
  max-width 980px
  margin 60px auto 35px auto
  h2
    united-heavy()
    uppercase()
    centered()
    font-size size-font-headline
    color #262626
    font-size size-font-headline-small
    margin-top 45px
    margin-bottom 20px
  p
    font-size size-font-3
    max-width 656px
    margin 0 auto
    margin-bottom 1em
</style>



// WEBPACK FOOTER //
// OnSitePage.vue?9a839354